<template>
  <div class="file-attachments" role="grid">
    <file-row
        v-for="file in files"
        :key="file.id"
        :file="file"
        @deleteFile="deleteFile">
    </file-row>
    <pagination
        v-if="pagination"
        :currentPage="currentPage"
        :totalPageCount="pagination.total_pages"
        @changePage="changePage">
    </pagination>
  </div>
</template>

<script>
  import AxiosMixin from '../mixins/AxiosMixin'
  import FileRow from './FileRow'
  import { mapGetters } from 'vuex'
  import Pagination from '../Shared/Pagination'

  export default {
    props: {
      files: Array,
      pagination: Object,
    },

    name: 'FileAttachments',

    mixins: [AxiosMixin],

    components: {
      FileRow,
      Pagination
    },

    data() {
      return {
        deletedFile: null,
      }
    },

    computed: {
      currentPage: function () {
        return this.pagination?.current_page
      },

      ...mapGetters(['brandId'])
    },

    methods: {
      changePage(page) {
        const isDiffPage = (this.currentPage && page) && (parseInt(page) !== parseInt(this.currentPage))
        isDiffPage && this.$emit('loadFiles', page)
      },

      deleteFile(file) {
        this.deletedFile = file
        const url = `/attachments/${file.id}/?uuid=${file.uuid}&brand_id=${this.brandId}`,
          methodType = 'delete'
        this.axiosMethod({url, methodType, onSuccess: this.onDeleteSuccess, onError: this.onDeleteError})
      },

      onDeleteError(error) {
        this.$emit('setMessage', `error deleting file ${this.deletedFile.file_name}: ${error}`, 'error')
        this.deletedFile = null
      },

      onDeleteSuccess(data) {
        const error = data.error
        if (error) {
          this.onDeleteError(error)
        } else {
          this.$emit('loadFiles')
          this.setSuccessMessage(`successfully deleted file ${this.deletedFile.file_name}`)
          this.$emit('setMessage', null, 'error')
          this.deletedFile = null
        }
      },

      setSuccessMessage(message) {
        this.$emit('setMessage', message, 'success')
      }
    },
  }
</script>

<style lang="sass">
  @import '../../assets/sass/colors'
  .file-attachments
    padding: 0.5rem

</style>